import StyleWrapper from 'publisher/components/core/StyleWrapper'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import {
  typedPageSelectors,
  usePage,
  useWebsiteSettings,
} from 'publisher/store'
import { getIsWebsitePageType } from 'publisher/store/page/pageSelectors'
import React from 'react'
import { getDefaultWebsiteLocale } from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonSearch } from 'src/shared/entities/search'
import { getPathnameWithLocale } from 'src/shared/entities/utils/get-url-with-locale'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import { BlogSearchAPIConnector } from './utils/blog-search-api-connector'
import { resolveSearchBasePath } from './utils/resolve-search-base-path'
import { WebsiteSearchAPIConnector } from './utils/website-search-api-connector'

interface SearchProps {
  entity: SearchInterface
}

export const Search = ({ entity }: SearchProps) => {
  const isWebsitePage = usePage(getIsWebsitePageType)
  const blogPath = resolveSearchBasePath(useBlog(blogSelectors.getBlogPath))
  const locale = usePage(state => typedPageSelectors.getLocale(state))
  const websiteDefaultLocale = useWebsiteSettings(getDefaultWebsiteLocale)
  const connector = isWebsitePage
    ? new WebsiteSearchAPIConnector(locale)
    : new BlogSearchAPIConnector(blogPath)
  const searchPath = isWebsitePage
    ? getPathnameWithLocale({
        locale,
        websiteDefaultLocale,
        pathname: 'search',
      })
    : `${blogPath}/search`

  const initialSearchTerm = React.useMemo(() => {
    if (typeof window === 'undefined') {
      return ''
    }
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get('query') ?? ''
  }, [])

  const config = {
    apiConnector: connector,
    trackUrlState: false,
    searchQuery: {},
    autocompleteQuery: {},
    initialState: {
      searchTerm: initialSearchTerm,
    },
    alwaysSearchOnInitialLoad: false,
  }

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonSearch
        config={config}
        searchPath={searchPath}
        item={entity.item}
        itemTitle={entity.itemTitle}
        itemText={entity.itemText}
        seeMore={entity.seeMore}
        dropdown={entity.dropdown}
        input={entity.input}
      />
    </StyleWrapper>
  )
}
